module.exports = __webpack_public_path__ + "media/site_templates/www.tv-installation.com.au/images/about_us-648c58b3c2b4cf1a150f89c1c1c53520.jpg";